import { Review } from "../../../types";
import { ReviewManagementState } from "../types/reviews-types";

/**
 * Resets review management state
 */
export const resetReviewState = (): ReviewManagementState => ({
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  editingReview: null,
  deletingReview: null,
});

/**
 * Opens edit drawer with review data
 */
export const openEditDrawer = (review: Review): ReviewManagementState => ({
  editingReview: review,
  isDrawerOpen: true,
  isDeleteModalOpen: false,
  deletingReview: null,
});

/**
 * Opens create drawer
 */
export const openCreateDrawer = (): ReviewManagementState => ({
  editingReview: null,
  isDrawerOpen: true,
  isDeleteModalOpen: false,
  deletingReview: null,
});

/**
 * Closes drawer
 */
export const closeDrawer = (): ReviewManagementState => ({
  editingReview: null,
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  deletingReview: null,
});

/**
 * Opens delete modal
 */
export const openDeleteModal = (review: Review): ReviewManagementState => ({
  editingReview: null,
  isDrawerOpen: false,
  isDeleteModalOpen: true,
  deletingReview: review,
});

/**
 * Closes delete modal
 */
export const closeDeleteModal = (): ReviewManagementState => ({
  editingReview: null,
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  deletingReview: null,
});

/**
 * Gets drawer title based on editing state
 */
export const getDrawerTitle = (editingReview: Review | null): string => {
  return editingReview ? "Редактировать отзыв" : "Создать отзыв";
};
